import { render } from "./ModalDeleteWindow.vue?vue&type=template&id=7b741a7e&scoped=true"
import script from "./ModalDeleteWindow.vue?vue&type=script&lang=js"
export * from "./ModalDeleteWindow.vue?vue&type=script&lang=js"

import "./ModalDeleteWindow.vue?vue&type=style&index=0&id=7b741a7e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b741a7e"]])

export default __exports__